import { render } from "./DknUartLatestParamsPanel.vue?vue&type=template&id=7653a6e6&scoped=true&ts=true"
import script from "./DknUartLatestParamsPanel.vue?vue&type=script&lang=ts"
export * from "./DknUartLatestParamsPanel.vue?vue&type=script&lang=ts"

import "./DknUartLatestParamsPanel.vue?vue&type=style&index=0&id=7653a6e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7653a6e6"]])

export default __exports__